//@flow
import * as React from 'react';
import {
  ProductSection,
  ContentSection,
  RetailerAttribution,
  Button,
} from '../';
import { Product, UGC } from 'models';
import { Set } from 'immutable';
import {
  brandEngageCard as cardCls,
  brandEngageCardMain as mainCls,
  brandEngageCardAside as asideCls,
  brandEngageCardOverlay,
  brandEngageCardSection,
} from './BrandEngageCard.scss';
import SectionSeparator from '../ModerationCard/SectionSeparator';
import Observation from '../../models/Observation';
import Loader from '../Common/Loader';
import { AutoHide } from 'components';
import { Alert } from 'components/alerts';

type Props = {
  product: Product,
  ugc: Object,
  status: ?RequestStatus,
  readonly?: boolean,
  children?: any,
  observations: Set<string>,
  onDismiss: () => void,
  dismissRequestStatus: ?RequestStatus,
};

class BrandEngageCard extends React.PureComponent<Props, void> {
  static defaultProps = {
    product: new Product(),
  };

  render() {
    const {
      product,
      ugc,
      status,
      children,
      observations,
      dismissRequestStatus,
      onDismiss,
      readonly,
    } = this.props;

    const pending = status === 'pending';
    const dismissPending = dismissRequestStatus === 'pending';
    const showDismissButton =
      readonly !== true && shouldShowDismissButton(ugc, observations);

    return (
      <div className={cardCls}>
        {pending && <div className={brandEngageCardOverlay} />}
        <div className={mainCls}>
          <ProductSection
            model={product}
            key={product.subject_id}
            brandName
            categoryName
          />
          <div className="mb4">
            <SectionSeparator />
          </div>
          <ContentSection
            key={`cc-${ugc.ugc_id}`}
            model={ugc}
            hideMeta={true}
            program="brand"
          />
          {React.Children.map(children, (child, ...args) => {
            return child ? (
              <div>
                <SectionSeparator />
                <div className={brandEngageCardSection}>{child}</div>
              </div>
            ) : null;
          })}
        </div>
        <div className={asideCls}>
          <div className={brandEngageCardSection}>
            <RetailerAttribution
              clientId={product.merchant.group_id}
              clientName={product.merchant.name}
              ugctype={getRetailerUgc(ugc).ugctype}
            />
            {showDismissButton && (
              <React.Fragment>
                <Button
                  className="w-100 white brandon mt3 f4"
                  style={{ backgroundColor: '#808284' }}
                  data-test="dismiss"
                  onClick={onDismiss}
                >
                  {dismissPending ? (
                    <Loader size="1.5em" thickness="0.15em" />
                  ) : (
                    'Dismiss'
                  )}
                </Button>
                {dismissRequestStatus instanceof Error && (
                  <AutoHide delay={3000}>
                    <br />
                    <Alert>Error dismissing content.</Alert>
                  </AutoHide>
                )}
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    );
  }
}

// In some cases the primary ugc is not the retailer ugc
// For attribution we need to find the retailer ugc (which is the parent ugctype)
// i.e Review | Question
function getRetailerUgc(primaryUgc: *) {
  if (primaryUgc.ugctype === 'BrandAnswer') {
    return primaryUgc.ugc_related_content.find(r => r.ugctype === 'Question');
  } else if (primaryUgc.ugctype === 'BrandMerchantResponse') {
    return primaryUgc.ugc_related_content.find(
      r => r.ugc_archetype === 'Review'
    );
  }

  return primaryUgc;
}

function shouldShowDismissButton(ugc: *, observations: *): boolean {
  const isDismissableUgcType =
    ugc.ugctype === 'Question' || ugc.ugc_archetype === 'Review';
  const isDismissed = observations.has(Observation.BrandEngaged);
  const hasBrandResponseOrAnswer = UGC.hasBrandResponseOrAnswer(ugc);

  return isDismissableUgcType && !isDismissed && !hasBrandResponseOrAnswer;
}

export default BrandEngageCard;



// WEBPACK FOOTER //
// ./src/components/BrandEngageCard/BrandEngageCard.js